// extracted by mini-css-extract-plugin
export var centerList = "_kq-6";
export var centerLoc = "_kq-a";
export var centerName = "_kq-9";
export var centerOptionBody = "_kq-8";
export var centerRow = "_kq-7";
export var centerStatus = "_kq-b";
export var empty = "_kq-5";
export var externalIcon = "_kq-c";
export var fieldHeader = "_kq-2";
export var fieldHelp = "_kq-4";
export var fieldLabel = "_kq-3";
export var panel = "_kq-0";
export var removeBtn = "_kq-d";
export var section = "_kq-1";